// extracted by mini-css-extract-plugin
module.exports = {"toggleButton":"HideProfileButton_toggleButton__OiM8f","openButton":"HideProfileButton_openButton__2zNjv"};